import { alicuotaFromFraction, formatAlicuota } from '@condo/domain-chile';

/** Format a fraction [0,1] as Chilean percentage "5,5000%". */
export function formatAlicuotaFraction(fraction: number): string {
  return formatAlicuota(alicuotaFromFraction(fraction));
}

/** Generic integer with Chilean separators: "1.234.567". */
export function formatInteger(value: number): string {
  return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(value);
}

/** Percentage 0-100 to "42,5%". */
export function formatPct(value: number, digits = 1): string {
  return `${new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value)}%`;
}

/** Format square meters. */
export function formatM2(value: number): string {
  return `${new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value)} m²`;
}
